import "core-js/modules/es.array.concat.js";
import request from '@/utils/request';
export var defaultMissionInfReadingData = {
  missionInfoId: '',
  title: '',
  content: '',
  order: 0
};
export var getMissionInfoReadings = function getMissionInfoReadings(missionInfoId) {
  return request({
    url: "/connect/api/v1/missionInfos/".concat(missionInfoId, "/readings"),
    method: 'get'
  });
};
export var getMissionInfoReading = function getMissionInfoReading(missionInfoId, id) {
  return request({
    url: "/connect/api/v1/missionInfos/".concat(missionInfoId, "/readings/").concat(id),
    method: 'get'
  });
};
export var createMissionInfoReading = function createMissionInfoReading(data) {
  return request({
    url: "/connect/api/v1/missionInfos/".concat(data.missionInfoId, "/readings"),
    method: 'post',
    data: data
  });
};
export var updateMissionInfoReading = function updateMissionInfoReading(data) {
  return request({
    url: "/connect/api/v1/missionInfos/".concat(data.missionInfoId, "/readings/").concat(data.id),
    method: 'put',
    data: data
  });
};
export var updateMissionInfoReadingOrder = function updateMissionInfoReadingOrder(missionInfoId, data) {
  return request({
    url: "/connect/api/v1/missionInfos/".concat(missionInfoId, "/order"),
    method: 'post',
    data: data
  });
};
export var deleteMissionInfoReading = function deleteMissionInfoReading(missionInfoId, id) {
  return request({
    url: "/connect/api/v1/missionInfos/".concat(missionInfoId, "/readings/").concat(id),
    method: 'delete'
  });
};